import Query from '../../../components/Report';

const query = (subdomain) =>
    new Query('search-urls-subdomain-detail', {
        subdomain,
    });

export default query;
